import React from "react";
import { Formik, Field, Form } from "formik";
import { Select, Loading } from "components/form";
import Modal from "components/Modal";
import { useCore } from "store/core";
import moment from "moment-jalaali";
import { TextField } from "components/form";

moment.loadPersian({ dialect: "persian-modern", usePersianDigits: false });

const startYear = 1399;
const currentYear = parseInt(moment().format("jYYYY"), 10);
const currentMonth = parseInt(moment().format("jM"), 10);

const years = Array.from({ length: currentYear - startYear + 1 }, (_, i) => {
  const year = startYear + i;
  return { label: String(year), value: year };
});

const months = [
  { label: "فروردین", value: 1 },
  { label: "اردیبهشت", value: 2 },
  { label: "خرداد", value: 3 },
  { label: "تیر", value: 4 },
  { label: "مرداد", value: 5 },
  { label: "شهریور", value: 6 },
  { label: "مهر", value: 7 },
  { label: "آبان", value: 8 },
  { label: "آذر", value: 9 },
  { label: "دی", value: 10 },
  { label: "بهمن", value: 11 },
  { label: "اسفند", value: 12 },
];

export default function MonthReport(props) {
  const core = useCore();
  const convertToGregorian = (jYear, jMonth, isEnd = false) => {
    if (!jYear || !jMonth) return null;

    const paddedMonth = String(jMonth).padStart(2, "0");
    const jDate = moment(`${jYear}-${paddedMonth}-01`, "jYYYY-jMM-jDD");

    if (!jDate.isValid()) return null;

    if (isEnd) {
      const endOfMonth = moment(jDate).add(1, "jMonth").subtract(1, "day");
      return endOfMonth.format("jYYYY-jMM-jDD");
    }

    return jDate.format("jYYYY-jMM-jDD");
  };

  return (
    <Modal
      show={props.show}
      handleClose={props.close}
      title="گزارش ماهانه کارگردان"
    >
      <Formik
        initialValues={{
          fromYear: "",
          fromMonth: "",
          toYear: "",
          toMonth: "",
          season: "",
        }}
        validate={(values) => {
          const errors = {};

          if (!values.fromYear || !values.fromMonth) {
            errors.fromMonth = "ماه شروع را کامل انتخاب کنید";
          }
          if (!values.toYear || !values.toMonth) {
            errors.toMonth = "ماه پایان را کامل انتخاب کنید";
          }

          const from = convertToGregorian(values.fromYear, values.fromMonth);
          const to = convertToGregorian(values.toYear, values.toMonth, true);

          if (from && to && from > to) {
            errors.toMonth = "ماه پایان باید بعد از ماه شروع باشد";
          }

          return errors;
        }}
        onSubmit={async (values, { setSubmitting }) => {
          const from = convertToGregorian(values.fromYear, values.fromMonth);
          const to = convertToGregorian(values.toYear, values.toMonth, true);

          if (!from || !to) {
            setSubmitting(false);
            return;
          }

          await core.dispatch(
            core.getDirectorMonthlyReport(
              props.item.id,
              from,
              to,
              values.season
            )
          );

          props.close();
          setSubmitting(false);
        }}
      >
        {({ isSubmitting, dirty, errors }) => (
          <Form>
            <div className="modal-body space-y-4">
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label className="block font-bold mb-1">از ماه:</label>
                  <div className="flex gap-2">
                    <Field
                      name="fromYear"
                      component={Select}
                      options={years}
                      placeholder="سال"
                    />
                    <Field
                      name="fromMonth"
                      component={Select}
                      options={months}
                      placeholder="ماه"
                    />
                  </div>
                </div>

                <div>
                  <label className="block font-bold mb-1">تا ماه:</label>
                  <div className="flex gap-2">
                    <Field
                      name="toYear"
                      component={Select}
                      options={years}
                      placeholder="سال"
                    />
                    <Field
                      name="toMonth"
                      component={Select}
                      options={months}
                      placeholder="ماه"
                    />
                  </div>
                </div>
              </div>

              <div>
                <label className="block font-bold mb-1">فصل:</label>
                <Field
                  name="season"
                  component={TextField}
                  placeholder="فصل"
                  className="w-full"
                />
              </div>
              {errors.toMonth && (
                <div className="text-danger text-sm text-right">
                  {errors.toMonth}
                </div>
              )}
            </div>

            <div className="modal-footer flex justify-end gap-2 mt-4">
              <button
                className="btn btn-primary w-24"
                type="submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? <Loading /> : "دریافت گزارش"}
              </button>
              <button
                type="button"
                disabled={isSubmitting}
                onClick={props.close}
                className="btn btn-outline-secondary w-24"
              >
                بستن
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </Modal>
  );
}
